import ChimeMeetControls from "../ChimeMeetControls/ChimeMeetControls";
import { useChimeMeeting } from "../../../Chime/ChimeMeetingContext";
import { LocalVideo, RosterAttendeeType, useAttendeeStatus, useRosterState } from "amazon-chime-sdk-component-library-react";
import images from "../../../assets/images";
import { Avatar } from "@mui/material";
import RemoteVideos from "../RemoteVideos";
import "./ChimeMeetGroup.scss";
import { getInitials } from "../../../utils/chimeHelper";
import { useEffect, useMemo } from "react";

interface ChimeMeetGroupProps{
  localAttendee: RosterAttendeeType & { color:string };
}

const ChimeMeetGroup = ({localAttendee}:ChimeMeetGroupProps) => {
  const { isHandRaised, attendeeId, hostId, participantsRef, attendeesDataRef, participantList, setParticipantsList } = useChimeMeeting();
  const {Microphone, MicrophoneOff, ParticipantRaiseHand} = images;
  const { muted, videoEnabled } = useAttendeeStatus(attendeeId ? attendeeId : "");
  const { roster } = useRosterState();
  // const [allAttendeeData, setAllAttendeeData] = useState<any>([]);
  
  useEffect( () => {
    if(roster && attendeeId){
      const attendeeKeys = Object.keys(roster);
      let temp :any[] = [];
      let partTemp: any = {};
      attendeeKeys.map( (id: any ) => { 
          const attendeeData = roster[id] as RosterAttendeeType & { color: string };
          partTemp[id] = {attendeeData, handRaised: participantsRef.current[id]?.handRaised ?? false};
          console.log('attendee data inside the loop=====>',attendeeData);
          if(attendeeData?.chimeAttendeeId !== attendeeId && !attendeeData?.externalUserId?.includes("aws:MediaPipeline") && attendeeData?.externalUserId &&  attendeeData?.chimeAttendeeId && attendeeData?.name){
              temp.push({
                  chimeAttendeeId : attendeeData?.chimeAttendeeId,
                  externalUserId: attendeeData?.externalUserId,
                  name: attendeeData?.name,
                  handRaised: participantsRef.current[attendeeData?.chimeAttendeeId]?.handRaised ?? false,
                  color: attendeeData?.color || '#bdbdbd'
              });
          }
      });
      participantsRef.current = partTemp;
      setParticipantsList(temp);
      attendeesDataRef.current = temp;
    }
  }, [roster]);

  const memoizedAttendees = useMemo(() => participantList, [participantList]);

  useEffect(() => {
    console.log("[Log] memoizedAttendees", memoizedAttendees);
  }, [memoizedAttendees])

  return (
    <div className="group-grid-chime">
      <div className="remote-tile-innerContainer">
        <div className="remote-tile-icon">
            <div className="micIconContainer">
                {/* <img src={ (audioEnabled && audioStream) ? Microphone : MicrophoneOff } className={(audioEnabled && audioStream && !screenShareEnabled && isHost) ? "clickMic" : "micIcon"} alt="videoOn" onClick={() => (audioEnabled && audioStream && !screenShareEnabled && isHost) ? muteUsers(userKey) : ''}/> */}
                <img src={ (muted) ? MicrophoneOff : Microphone } className={"micIcon"} alt="videoOn" />
            </div>
            <div className="handIconContainer">
                <img src={ParticipantRaiseHand} className={isHandRaised ? 'raiseHandStyle' : 'raiseHandHidden'} alt="videoOn"/>
            </div>
        </div>
        {videoEnabled ? (
          <>
            <LocalVideo className='remote-video' />
            <div className="participantName">
              <span style={{ textShadow: "0 1px 2px rgba(0,0,0,.6),0 0 2px rgba(0,0,0,.3)", letterSpacing: "1px" }}>
                {localAttendee?.name ?
                  `${(localAttendee?.name)?.charAt(0).toUpperCase() + (localAttendee?.name)?.slice(1)} ${localAttendee?.externalUserId === hostId ? `(Host)` : ''}`
                  : ""}
              </span>
            </div>
          </>) : (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'black' }} className="remote-video">
            <Avatar sx={{ width: 80, height: 80, fontSize: 24, fontWeight: 600, zIndex: 1 , backgroundColor: localAttendee?.color }}>{getInitials(localAttendee?.name)}</Avatar>
            <div className="participantName">
              <span style={{ textShadow: "0 1px 2px rgba(0,0,0,.6),0 0 2px rgba(0,0,0,.3)", letterSpacing: "1px" }}>
                {localAttendee?.name ?
                  `${(localAttendee?.name)?.charAt(0).toUpperCase() + (localAttendee?.name)?.slice(1)} ${localAttendee?.externalUserId === hostId ? `(Host)` : ''}`
                  : ""}
              </span>
            </div>
          </div>
        )}
    </div>
    {memoizedAttendees?.map( (attendee: any, index: number) =>  <RemoteVideos Attendee={attendee} key={attendee.externalUserId ?? attendee.chimeAttendeeId} hand={attendee.handRaised} />)}

      {/* Controls */}
      <div className="shadow" />
      <div className="meetControls">
        <ChimeMeetControls />
      </div>
    </div>
  );
};

export default ChimeMeetGroup;
